import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as filterRecordsActions from '../reducer';


function filterWrapper(WrappedComponent, requiredFilterKey) {
  class FilteringComponent extends Component {
    static get propTypes() {
      return {
        filterKey: PropTypes.string,
        filterStaticDataKey: PropTypes.string,
        setDisplayFilter: PropTypes.func,
        staticData: PropTypes.object
      };
    }


    render() {
      const { filterKey, setDisplayFilter } = this.props;

      const filterProps = {
        filterKey,
        requiredFilterKey,
        setDisplayFilter,
      };

      return (
        <WrappedComponent {...filterProps} {...this.props} />
      );
    }
  }

  const mapStateToProps = state => ({
    filterKey: state.filterRecords.filterKey,
    staticData: state.staticData
  });

  const mapDispatchToProps = (dispatch) => {
    const {
      setDisplayFilter,
    } = bindActionCreators(filterRecordsActions, dispatch);

    return {
      setDisplayFilter
    };
  };

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(FilteringComponent);
}

export default filterWrapper;



// WEBPACK FOOTER //
// ./src/filter/filterTypes/filterWrapper.js